import React from "react";
import PropTypes from "prop-types";
import Divider from "@mui/material/Divider";

const SFDivider = (props) => {
  return <Divider orientation={props.orientation} flexItem={props.flexItem} {...props}>{props.children}</Divider>;
};

SFDivider.defaultProps = {
  orientation: "horizontal",
};

SFDivider.propTypes = {
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  flexItem: PropTypes.bool,
  children: PropTypes.node
};

export default SFDivider;
